import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ClientProgressMonitor = ({ progressData, onViewFullProgress }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="TrendingUp" size={24} color="var(--color-success)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Client Progress</h2>
            <p className="text-sm text-muted-foreground">Recent achievements</p>
          </div>
        </div>
      </div>
      <div className="space-y-4">
        {progressData?.map((progress) => (
          <div
            key={progress?.id}
            className="p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250"
          >
            <div className="flex items-start gap-4 mb-3">
              <Image
                src={progress?.clientAvatar}
                alt={progress?.clientAvatarAlt}
                className="w-12 h-12 rounded-full object-cover flex-shrink-0"
              />
              <div className="flex-1 min-w-0">
                <h3 className="text-base font-medium text-foreground">{progress?.clientName}</h3>
                <p className="text-sm text-muted-foreground">{progress?.achievement}</p>
              </div>
              <span className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success flex-shrink-0">
                {progress?.date}
              </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {progress?.metrics?.map((metric, index) => (
                <div key={index} className="p-3 rounded-lg bg-muted">
                  <div className="flex items-center gap-2 mb-1">
                    <Icon name={metric?.icon} size={16} color="var(--color-primary)" />
                    <span className="text-xs text-muted-foreground">{metric?.label}</span>
                  </div>
                  <p className="text-lg font-semibold text-foreground">{metric?.value}</p>
                  {metric?.change && (
                    <p className={`text-xs mt-1 ${metric?.change?.startsWith('+') ? 'text-success' : 'text-error'}`}>
                      {metric?.change}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {progress?.photos && progress?.photos?.length > 0 && (
              <div className="mt-4">
                <p className="text-sm font-medium text-foreground mb-2">Progress Photos</p>
                <div className="grid grid-cols-3 gap-2">
                  {progress?.photos?.map((photo, index) => (
                    <div key={index} className="relative aspect-square rounded-lg overflow-hidden">
                      <Image
                        src={photo?.url}
                        alt={photo?.alt}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-2">
                        <p className="text-xs text-white">{photo?.date}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-4">
        <Button variant="ghost" fullWidth onClick={onViewFullProgress}>
          View All Progress Reports
        </Button>
      </div>
    </div>
  );
};

export default ClientProgressMonitor;